package kz.dentalcrm.app.data.network.response_model.employees

import kotlinx.serialization.Serializable

@Serializable
data class EmployeesResponse(
    val current_page: Int? = null,
    val `data`: List<Employee>? = null,
    val first_page_url: String? = null,
    val from: Int? = 0,
    val last_page: Int? = 0,
    val last_page_url: String? = null,
    val next_page_url: String? = null,
    val path: String? = null,
    val per_page: Int? = null,
    val prev_page_url: String? = null,
    val to: Int? = null,
    val total: Int? = null
)